import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=350c542e&scoped=true"
import script from "./Questionaire.vue?vue&type=script&lang=js"
export * from "./Questionaire.vue?vue&type=script&lang=js"
import style0 from "./Questionaire.vue?vue&type=style&index=0&id=350c542e&prod&lang=scss"
import style1 from "./Questionaire.vue?vue&type=style&index=1&id=350c542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c542e",
  null
  
)

export default component.exports